import { render, staticRenderFns } from "./PFlag.vue?vue&type=template&id=1eabd9a8"
import script from "./PFlag.vue?vue&type=script&lang=js"
export * from "./PFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports